<template>
  <v-sheet v-if="items" color="grey lighten-2" class="informative-section">
    <LoadingWidget v-if="loading" />
    <v-container v-else class="relative">
      <div
        class="
          d-flex
          justify-sm-space-between justify-center
          flex-column flex-sm-row
        "
      >
        <TitleWidget>Informativos</TitleWidget>
        <div
          class="
            slides-nav
            mt-10 mt-sm-0
            justify-center justify-sm-space-between
          "
        >
          <a
            class="d-flex align-center justify-center slides-nav-item"
            @click.prevent="slidePrev"
          >
            <img
              height="36px"
              src="../../assets/img/arrow-left.svg"
              alt="right"
            />
          </a>
          <a
            class="d-flex align-center justify-center slides-nav-item"
            @click.prevent="slideNext"
          >
            <img
              height="36px"
              src="../../assets/img/arrow-right.svg"
              alt="right"
            />
          </a>
        </div>
      </div>

      <div class="px-4">
        <div class="mx-n4">
          <hooper-container
            v-if="items.length"
            class="slides-container"
            style="height: auto"
            :settings="hooperSettings"
            ref="carousel"
            :wheelControl="false"
            :infiniteScroll="true"
            @slide="updateCarousel"
          >
            <hooper-slide class="item" v-for="(item, i) in items" :key="i">
              <v-sheet width="100%" color="transparent" class="px-4">
                <InformativeCard v-bind="item" />
              </v-sheet>
            </hooper-slide>
          </hooper-container>
        </div>
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
import { getYoutubeCode } from "../../utils/getYoutubeCode";
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import InformativeCard from "../cards/InformativeCard.vue";

const _config = {
  mod: "informative",
};
export default {
  data: () => ({
    model: 0,
    dialog: {},
    loading: false,
    carouselData: 0,
    hooperSettings: {
      breakpoints: {
        0: {
          itemsToShow: 2,
        },
        600: {
          itemsToShow: 2.5,
        },
        800: {
          itemsToShow: 3,
        },
        1100: {
          itemsToShow: 4,
        },
      },
    },
  }),
  components: {
    LoadingWidget,
    InformativeCard,
    TitleWidget,
  },
  computed: {
    items() {
      return this.$rest(_config.mod).list.map((e) => {
        return {
          id: e.id,
          img: e.img,
          video: "https://www.youtube.com/embed/" + getYoutubeCode(e.video),
        };
      });
    },
  },
  methods: {
    slidePrev() {
      this.$refs.carousel.slidePrev();
    },
    slideNext() {
      this.$refs.carousel.slideNext();
    },
    updateCarousel(payload) {
      this.myCarouselData = payload.currentSlide;
    },
  },
  watch: {
    carouselData() {
      this.$refs.carousel.slideTo(this.carouselData);
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get()
      .then((this.loading = false));
  },
};
</script>

<style lang="scss" scoped>
.informative-section {
  padding-bottom: 120px;
  padding-top: 73px;
  position: relative;
}

.slides-nav {
  display: flex;
  gap: 48px;

  &-item {
    transition: all 0.15s;

    img {
      @media (max-width: 600px) {
        height: 25px;
      }
    }

    &:hover {
      opacity: 0.7;
    }
  }
}
.slides-container::v-deep {
  margin-top: 80px;

  @media (max-width: 600px) {
    margin-top: 30px;
  }

  ul,
  ol {
    padding: 0 !important;
  }
}
</style>
